export enum PromotionType {
  Special = 1,
  Federal = 2,
  Partner = 7,
  Popular = 9,
  CategoryDiscount = 12,
  Raffle = 13,
  Selection = 19,
}
